import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerModule, NgxSpinnerService} from 'ngx-spinner';
import {IProject} from '../../shared/model/project.model';
import {ProjectService} from '../project/project.service';
import {FileObjectService} from './file-object.service';
import {FileObject, IFileObject} from '../../shared/model/file-object.model';

// import { JhiEventManager } from 'ng-jhipster';


@Component({
  selector: 'app-file-delete-dialog',
  templateUrl: './file-delete-dialog.component.html'
})
export class FileDeleteDialogComponent implements OnInit {
  file: IFileObject = new FileObject();
  @Input() fileEdit;
  @Input() action;
  isSaving: boolean;
  showMsg = false;
  projects: IProject[];


  constructor(protected projectService: ProjectService,
              protected fileService: FileObjectService,
              public activeModal: NgbActiveModal,
              private toastr: ToastrService,
              public router: Router,
              public spinner: NgxSpinnerService
              // protected eventManager: JhiEventManager
  ) {
  }

  ngOnInit() {
    if (this.fileEdit) {
// alert('fileEdi='+ +this.fileEdit);
      this.fileService.find(this.fileEdit).subscribe(
        (res: HttpResponse<IFileObject>) => {
          this.file = res.body;
        }
      );
    }
  }


  protected onError(errorMessage: string) {
  }

  delete() {
    this.spinner.show();

    this.file.isdeleted = true;

    if (this.file.id !== undefined) {
      this.subscribeToSaveResponseUpdateToFile(this.fileService.update(this.file));
    }
  }


  protected subscribeToSaveResponseUpdate(result: Observable<HttpResponse<IFileObject>>) {
    result.subscribe((res: HttpResponse<IFileObject>) => this.onSaveSuccessUpdate(res), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected subscribeToSaveResponseUpdateToFile(result: Observable<HttpResponse<IFileObject>>) {
    result.subscribe((res: HttpResponse<IFileObject>) => this.onSaveSuccessUpdateToFile(res), (res: HttpErrorResponse) => this.onSaveError());
  }


  protected onSaveError() {
    this.isSaving = false;
  }

  protected onSaveSuccessUpdate(res) {
    this.file = res.body;
    // this.isSaving = false;
    this.toastr.success('     ثبت تغييرات با موفقیت انجام شد.     ', '   کاربر گرامی!    ');
    this.clear();
    this.spinner.hide();
    this.router.navigate(['/page/file-archive-page']);


  }

  protected onSaveSuccessUpdateToFile(res) {
    this.file = res.body;
    // this.isSaving = false;
    this.toastr.success('     ثبت تغييرات با موفقیت انجام شد.     ', '   کاربر گرامی!    ');
    this.clear();
    this.spinner.hide();
    // this.router.navigate(['/page/files']);


  }

  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmDelete(id: number) {
    this.fileService.delete(id).subscribe(response => {
      this.activeModal.dismiss(true);
    });
  }
}
